import { ChangeEvent, useCallback } from "react"
import { FilterItemProps, inputClasses } from "../_common"

export function TextFilter({
    name,
    value,
    handleChange,
}: FilterItemProps<string>) {
    const onChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const val = e.currentTarget.value
            val && handleChange?.(val)
        },
        [handleChange]
    )
    return (
        <input
            type="text"
            name={name}
            id={name}
            className={inputClasses}
            placeholder={name}
            onChange={onChange}
            value={value}
        />
    )
}